<template>
    <div>
      <label for="unidade" class="required">Unidade:</label>
      <select v-model="selected" @change="enviarEmit" id="unidade">
        <option v-for="u in unidades" :key="u.id" :value="u">
          {{ u.descricao }}
        </option>
      </select>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Unidade',
    emits: ['unidade-selecionada'],
    props: {
      valor: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        unidades: [],
        selected: ''
      };
    },

    methods: {

      async getUnidades() {
            //console.log("Chamou endpoint '/unidade'");
            try {
                const path = '/unidade';
                const response = await this.$axios.get(path);
                this.unidades = response.data;
            } catch (error) {
                 if (error.response) {
                     console.error('(buscando unidade) Resposta do servidor com status:', error.response.status);
                 } else {
                     console.error('(buscando unidade) Erro sem resposta do servidor:', error.message);
                 }
            }

        },

    enviarEmit() {
        this.$emit('unidade-selecionada', this.selected);
      }
    },

    mounted() {
      this.getUnidades();
    },

  };
  </script>
  
  <style scoped>
  /* Adicione estilos específicos para o componente aqui, se necessário */
  </style>